import { z } from 'zod';
import { FrontendSlideSchema } from './SlideType';

export const APIResponseGroupSchema = z.object({
  id: z.string(),
  index: z.number(),
  name: z.string(),
});

export const SlideGroupSchema = APIResponseGroupSchema.extend({
  slides: z.record(FrontendSlideSchema),
});

const SlideGroupRecordSchema = z.record(SlideGroupSchema);

export type SlideGroupType = z.infer<typeof SlideGroupSchema>;
export type SlideGroupRecord = z.infer<typeof SlideGroupRecordSchema>;
